import React from 'react';
import theme from './ChangeRequestDetailsTotalRow.module.scss';
import { Trans } from '@lingui/react/macro';
import { sumBy } from 'lodash-es';
import { ChangeRequestParticipantInfo } from '@/types';
import { ProjectCurrencyDisplay } from '@/seller/components/currency';

interface ChangeRequestDetailsTotalRowProps {
    participants: ChangeRequestParticipantInfo[];
}

const ChangeRequestDetailsTotalRow: React.FC<ChangeRequestDetailsTotalRowProps> = ({ participants }) => {
    return (
        <div className={theme.total}>
            <div className={theme.totalRow}>
                <Trans>Total price</Trans>

                <span>
                    <ProjectCurrencyDisplay
                        value={sumBy(
                            participants!.flatMap((x) => x.offerLines),
                            (x) => x?.priceCalculation?.finalPrice ?? 0
                        )}
                    />
                </span>
            </div>

            <small className={theme.totalRow}>
                <span>
                    (
                    <ProjectCurrencyDisplay
                        value={sumBy(
                            participants!.flatMap((x) => x.offerLines),
                            (x) => x?.priceCalculation?.basePrice ?? 0
                        )}
                    />
                    )
                </span>
            </small>
        </div>
    );
};

export default ChangeRequestDetailsTotalRow;
